/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ProcessResponse } from '../../models/process-response';

export interface GetProcess1$Params {
  configId: string;
  processId: string;
}

export function getProcess1(http: HttpClient, rootUrl: string, params: GetProcess1$Params, context?: HttpContext): Observable<StrictHttpResponse<ProcessResponse>> {
  const rb = new RequestBuilder(rootUrl, getProcess1.PATH, 'get');
  if (params) {
    rb.path('configId', params.configId, {});
    rb.path('processId', params.processId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ProcessResponse>;
    })
  );
}

getProcess1.PATH = '/config/{configId}/process/{processId}';
